/**
 * Experiments created on Petri should be listed here.
 *
 * #### Scopes
 *
 * Any new created specs should be conducted via centralized conduction.
 *
 * This means that they should be created with the following scopes:
 *
 * |            | Scope                                              |
 * | :-         | :-                                                 |
 * | Backoffice | `bm-apps-14bcded7-0066-7c35-14d7-466cb3f09103`     |
 * | Viewer     | `viewer-apps-14bcded7-0066-7c35-14d7-466cb3f09103` |
 */
export const EXPERIMENTS = {
    USE_MEDIA: 'specs.wixBlog.useMedia',
    USE_WARMUP_STATE_IN_FEED: 'specs.wixBlog.UseWarmupStateInFeed',
    USE_WARMUP_STATE_IN_POST_LIST: 'specs.wixBlog.UseWarmupStateInPostList',
    IS_MA_MODAL_ENABLED: 'specs.wixBlog.isMAModalEnabled',
    /**
     * https://bo.wix.com/petri/experiments/2172660
     * - Switches to using WSR Toast component for displaying messages.
     **/
    USE_WSR_TOAST: 'specs.wixBlog.UseToast',
    /**
     * https://bo.wix.com/petri/experiments/2232767
     * - Adding Ai Img Generator btn to add panel items.
     **/
    AI_IMG_GENERATOR: 'specs.wixBlog.AiImgGenerator',
    /**
     * https://bo.wix.com/petri/experiments/2148532
     * - Enables "CSS per Breakpoint" compatibility.
     */
    CSS_PER_BREAKPOINT: 'specs.wixBlog.cssPerBp',
    /**
     * https://bo.wix.com/petri/experiments/2575680
     * - Enables Analytics in BM Blog Overview
     */
    BM_ANALYTICS: 'specs.wixBlog.Analytics',
    /**
     * https://bo.wix.com/petri/experiments/2434693
     * - Swaps the API used to platformized when retrieving post content
     */
    USE_RICH_CONTENT: 'specs.wixBlog.UseRichContent',
    /**
     * https://bo.wix.com/petri/experiments/2438127
     * - Blog Live Site Editor Deprecation
     */
    LIVE_SITE_EDITOR_DEPRECATION: 'specs.wixBlog.LiveSiteEditorDeprication',
    /**
     * https://bo.wix.com/petri/experiments/2521350
     * - Allow trailing slash in Post Composer SEO panel
     */
    ALLOW_SLUG_TRAILING_SLASH: 'specs.wixBlog.AllowSlugTrailingSlash',
    /**
     * https://bo.wix.com/petri/experiments/2667709
     * - Displays "Blog Apps" Panel in Post Composer
     **/
    BLOG_APPS_PANEL: 'specs.wixBlog.BlogAppsPanel',
    /**
     * https://bo.wix.com/petri/experiments/2565957
     * - use blog-apps-test tag to test apps before add them to live app collection https://bo.wix.com/tag-manager/tag/2bbb6e0b-2cff-4902-a45e-e5fc581ae94f/apps
     **/
    BLOG_APPS_TEST_TAG: 'specs.wixBlog.BlogAppsTestTag',
    /**
     * https://bo.wix.com/petri/experiments/2590748
     * - use load more apps with modal grid flow
     **/
    BLOG_APPS_MODAL_GRID: 'specs.wixBlog.BlogAppsModalGrid',
    /**
     * https://bo.wix.com/petri/experiments/2706983
     * - Enable comments installation in new post page
     */
    ENABLE_COMMENTS_INSTALLATION: 'specs.wixBlog.EnableCommentsInNewPostPage',
    /**
     * https://bo.wix.com/petri/experiments/2759147
     * - Use Post editor Ai Tools Panel
     */
    POST_EDITOR_AI_TOOLS: 'specs.wixBlog.PostEditorAiTools',
    /**
     * https://bo.wix.com/petri/experiments?filter=specs.ident.monetization
     * - Swaps "+ Author" flow in "Posts -> Composer -> Settings -> Author field" to
     * be similar to the one in "Writers -> Add Writer"
     */
    IDENTITY_MONETIZATION: 'specs.ident.monetization',
    /**
     * https://bo.wix.com/petri/experiments/2968347
     * - Enable moving comments between posts feature in BM
     */
    ENABLE_MOVING_COMMENTS: 'specs.wixBlog.EnableMovingComments',
    /**
     * https://bo.wix.com/petri/experiments/2965044
     * - Increase excerpt to 500 symbols.
     */
    POST_EXCERPT: 'specs.wixBlog.Excerpt',
    /**
     * https://bo.wix.com/petri/experiments/3008775
     * - Used to navigate in wordpress blogs, that need post links to be on the site root (wix.com/blog/photography/2019/01/post)
     **/
    USE_SITE_ROOT_LINKS: 'specs.wixBlog.UseSiteRootLinks',
    /**
     * https://bo.wix.com/petri/experiments/2999108
     * Adds "Post Radius" control in Post List / Feed setting panels
     **/
    POST_ROUNDED_CORNERS: 'specs.wixBlog.PostRoundedCorners',
    /**
     * https://bo.wix.com/petri/experiments/3001259
     * - New Info Tooltip in Post Composer
     **/
    NEW_POST_COMPOSER_INFO_BUTTON: 'specs.wixBlog.NewPostComposerInfo',
    /**
     * https://bo.wix.com/petri/experiments/2987145
     * - Warmup Data in Old Post Page
     **/
    USE_WARMUP_STATE_IN_OLD_POST_PAGE: 'specs.wixBlog.UseWarmupStateInOldPostPage',
    /**
     * https://bo.wix.com/petri/experiments/2999324
     * Shows Design Post and Helper Center actions buttons within post composer in BM
     */
    SHOW_ACTION_BUTTONS_FOR_DESIGN_AND_HELP_CENTER: 'specs.wixBlog.DisplayDesignAndHelpCenterActionButtons',
    /**
     * https://bo.wix.com/petri/experiments/3033246
     * New Post Page on Blocks.
     **/
    NEW_POST_PAGE: 'specs.wixBlog.NewPostPage',
    /**
     * https://bo.wix.com/petri/experiments/3043681
     * Limit pagination to 100 pages due to BE limitations
     */
    LIMIT_PAGINATION_TO_100_PAGES: 'specs.wixBlog.LimitPaginationTo100Pages',
    /**
     * https://bo.wix.com/petri/experiments/3086642
     * - OOI: Old post page comments on SRR and SEO
     **/
    POST_PAGE_COMMENTS_SEO: 'specs.wixBlog.PostPageCommentsSEO',
    /**
     * https://bo.wix.com/petri/experiments/3260303
     */
    MULTIPLE_COLORS_FIX: 'specs.wixBlog.FixMultipleColors',
};
//# sourceMappingURL=experiments.js.map